<ng-container *ngIf="ctx as u">
  <ng-container *ngIf="hasContent">
    <details
      #d
      class="gw-bg-background-elevation-2 gw-border-base gw-rounded-2xl gw-overflow-hidden gw-gatewee-collapsible-details"
    >
      <summary
        class="gw-flex gw-flex-wrap gw-items-center gw-justify-between gw-gap-small gw-rounded-t-2xl gw-p-medium gw-cursor-pointer gw-list-none gw-select-none gw-outline-none gw-transition-colors gw-duration-300 gw-ease-out hover:gw-bg-background-neutral-1 focus-visible:gw-ring-2 focus-visible:gw-ring-background-accent-1"
      >
        <span class="gw-flex gw-items-center gw-gap-small gw-min-w-0">
          <gatewee-icon
            [icon]="'@tui.globe'"
            class="gw-shrink-0 gw-text-text-primary"
          ></gatewee-icon>
          <span class="gw-text-base gw-font-semibold gw-text-text-primary">
            {{ 'common.userContext.title' | translate }}
          </span>
        </span>
        <span
          class="gw-flex gw-min-w-0 gw-max-w-[55%] gw-items-center gw-justify-end gw-gap-2x-small"
        >
          <span
            *ngIf="summaryHint"
            class="gw-truncate gw-text-sm gw-font-medium gw-text-text-secondary"
          >
            {{ summaryHint }}
          </span>
          <gatewee-expand-chevron
            [expanded]="d.open"
            class="gw-inline-flex gw-shrink-0 gw-text-text-secondary"
          ></gatewee-expand-chevron>
        </span>
      </summary>
      <div class="gw-gatewee-collapsible-panel">
        <div
          class="gw-gatewee-collapsible-panel-inner gw-border-t gw-border-border-normal gw-px-medium gw-pb-medium gw-pt-medium"
        >
          <div
            class="gw-grid gw-grid-cols-1 sm:gw-grid-cols-2 md:gw-grid-cols-4 gw-gap-medium"
          >
            <div *ngIf="u.date">
              <p
                class="gw-text-sm gw-font-medium gw-text-text-secondary gw-mb-medium"
              >
                {{ 'features.withdrawals.view.labels.contextDate' | translate }}
              </p>
              <p class="gw-text-base gw-text-text-primary">
                {{ u.date | date : 'dd/MM/yyyy HH:mm' }}
              </p>
            </div>
            <div *ngIf="u.origin">
              <p
                class="gw-text-sm gw-font-medium gw-text-text-secondary gw-mb-medium"
              >
                {{ 'features.withdrawals.view.labels.origin' | translate }}
              </p>
              <p class="gw-text-base gw-text-text-primary">
                {{ u.origin }}
              </p>
            </div>
            <div *ngIf="u.ipAddress" class="sm:gw-col-span-2">
              <p
                class="gw-text-sm gw-font-medium gw-text-text-secondary gw-mb-medium"
              >
                {{ 'features.withdrawals.view.labels.ipAddress' | translate }}
              </p>
              <p
                class="gw-text-base gw-text-text-primary gw-font-mono gw-text-sm"
              >
                {{ u.ipAddress }}
              </p>
            </div>
            <div *ngIf="u.userAgent" class="md:gw-col-span-4">
              <p
                class="gw-text-sm gw-font-medium gw-text-text-secondary gw-mb-medium"
              >
                {{ 'features.withdrawals.view.labels.userAgent' | translate }}
              </p>
              <p class="gw-text-sm gw-text-text-secondary gw-break-all">
                {{ u.userAgent }}
              </p>
            </div>
            <div *ngIf="u.referer" class="md:gw-col-span-2">
              <p
                class="gw-text-sm gw-font-medium gw-text-text-secondary gw-mb-medium"
              >
                {{ 'common.userContext.referer' | translate }}
              </p>
              <p class="gw-text-sm gw-text-text-primary gw-break-all">
                {{ u.referer }}
              </p>
            </div>
            <div *ngIf="u.locale">
              <p
                class="gw-text-sm gw-font-medium gw-text-text-secondary gw-mb-medium"
              >
                {{ 'common.userContext.locale' | translate }}
              </p>
              <p class="gw-text-base gw-text-text-primary">
                {{ u.locale }}
              </p>
            </div>
            <div *ngIf="u.deviceId" class="sm:gw-col-span-2">
              <p
                class="gw-text-sm gw-font-medium gw-text-text-secondary gw-mb-medium"
              >
                {{ 'common.userContext.deviceId' | translate }}
              </p>
              <p
                class="gw-text-base gw-text-text-primary gw-font-mono gw-text-sm gw-break-all"
              >
                {{ u.deviceId }}
              </p>
            </div>
            <div *ngIf="u.fingerprint" class="sm:gw-col-span-2">
              <p
                class="gw-text-sm gw-font-medium gw-text-text-secondary gw-mb-medium"
              >
                {{ 'common.userContext.fingerprint' | translate }}
              </p>
              <p
                class="gw-text-base gw-text-text-primary gw-font-mono gw-text-sm gw-break-all"
              >
                {{ u.fingerprint }}
              </p>
            </div>
            <div *ngIf="u.sessionId" class="sm:gw-col-span-2">
              <p
                class="gw-text-sm gw-font-medium gw-text-text-secondary gw-mb-medium"
              >
                {{ 'common.userContext.sessionId' | translate }}
              </p>
              <p
                class="gw-text-base gw-text-text-primary gw-font-mono gw-text-sm gw-break-all"
              >
                {{ u.sessionId }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </details>
  </ng-container>
</ng-container>
